import OrganizationObject from "api/lib/data/interfaces/OrganizationObject";
import Organizations from "api/lib/data/Organizations";
import * as Joi from "joi";
import * as React from "react";
import { Form as UIForm, Message } from "semantic-ui-react";
import {
  Form,
  IInterfaceFormProps,
  IInterfaceFormState,
} from "src/components/Form";
import * as routes from "../../constants/routes";

interface IInterfaceProps extends IInterfaceFormProps {
  authUser: any;
  orgId: string;
}

interface IInterfaceState extends IInterfaceFormState {
  error: any;
}

export class OrganizationForm extends Form<IInterfaceProps, IInterfaceState> {
  private static INITIAL_STATE = {
    data: {
      name: "",
    },
    error: null,
    errors: {},
  };

  private static schema: Joi.SchemaLike = {
    name: Joi.string().required().label("Name"),
  };
  private static propKey(propertyName: string, value: any): object {
    return { [propertyName]: value };
  }

  constructor(props: IInterfaceProps) {
    super(props, OrganizationForm.schema);
    this.state = {
      ...Form.FORM_INITAL_STATE,
      ...OrganizationForm.INITIAL_STATE,
    };
  }

  public render() {
    const { error } = this.state;

    return (
      <UIForm onSubmit={this.handleSubmit} size="small">
        {this.renderInput("name", "Name", true)}

        <div style={{ width: "340px", textAlign: "right" }}>
          {this.renderButton("Save")}
        </div>
        {error && <Message error={true} header={error.message} />}
      </UIForm>
    );
  }
  protected doSubmit(callback: () => void) {
    const { data } = this.state;
    const { authUser, history } = this.props;
    const org = new Organizations();
    const orgObj: OrganizationObject = {
      request: {
        name: data.name,
        audit: {
          createdBy: authUser.uid,
          updatedBy: authUser.uid,
        },
      },
    };
    org
      .createOrg(authUser.uid, orgObj)
      .then(() => {
        this.setState(() => ({ ...OrganizationForm.INITIAL_STATE }));
        callback();
        history.push(routes.ORGANIZATIONS);
      })
      .catch((error) => {
        callback();
        this.setState(OrganizationForm.propKey("error", error));
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationForm.tsx